import React, { Component } from 'react';
import { connect } from 'react-redux';
import PageTitle from '../../components/PageTitle';
import { getListOa, grantPermission } from '../../redux/actions/Zalo';
import { Avatar, Button, Table, Tag, Tooltip } from 'antd';
import _ from 'lodash';
import qs from 'qs';
import { ReloadOutlined, UserOutlined } from '@ant-design/icons';
import { cleanObject, isValidDate, stripHtml } from '../../utils/helpers';
import { checkPermission } from '../../utils/permission';
import TableActionBar from '../../components/TableActionBar';
import TextTruncate from 'react-text-truncate';
import HtmlParser from 'react-html-parser';

const routes = [
    {
        path: '/',
        breadcrumbName: 'Trang chủ',
    },
    {
        path: '/zalo-oa',
        breadcrumbName: 'Zalo OA',
    },
]

class ZaloOAList extends Component {
    constructor(props) {
        super(props);
        this.popup = null;
        this.handleMessage = this.handleMessage.bind(this);

        this.state = {
            isLoading: false,
            selectedRowKeys: []
        }

    }

    componentDidMount() {
        var query = qs.parse(this.props.location.search.slice(1));
        this.reloadData(query);
        window.addEventListener('message', this.handleMessage);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.location.search !== this.props.location.search.slice()) {
            var query = qs.parse(nextProps.location.search.slice(1));
            this.setState({ isLoading: true });
            this.reloadData(query);
        }
    }

    componentWillUnmount() {
        window.removeEventListener('message', this.handleMessage);
    }

    handleMessage(event) {
        if (event.origin !== window.location.origin) return;

        const { type, token, error } = event.data;

        if (type === 'zalo-auth-success') {
            console.log('Nhận token từ Zalo:', token);
            // Bạn có thể lưu token hoặc gọi API khác tại đây
        }

        if (type === 'zalo-auth-fail') {
            console.error('Zalo xác thực thất bại:', error);
        }
    }

    async openPopup() {
        try {
            const url = await this.props.grantPermission();
            console.log(url);

            if (url) {
                this.popup = window.open(
                    url,
                    'ZaloOAuthPopup',
                    'width=800,height=800'
                );

                if (!this.popup) {
                    alert('Trình duyệt đang chặn popup. Vui lòng cho phép!');
                }
            } else {
                alert('Không lấy được URL xác thực từ server.');
            }
        } catch (err) {
            console.error('Lỗi khi mở popup:', err);
            alert('Lỗi hệ thống.');
        }
    }

    reloadData(query) {
        this.setState({ isLoading: true });
        this.props.getListOa(query).then(() => {
            this.setState({ isLoading: false });
        })
    }

    onChangeFilter(name, value) {
        var query = qs.parse(this.props.location.search.slice(1));
        query = {
            ...query,
            [name]: value
        }

        query = cleanObject(query);

        this.props.history.push({
            pathname: this.props.location.pathname,
            search: qs.stringify(query)
        });
    }

    onChangeTable(pagination, sorter) {
        var query = qs.parse(this.props.location.search.slice(1));
        if (!_.isEmpty(pagination)) {
            query = {
                ...query,
                page: pagination.current,
                per_page: pagination.pageSize,
            }
        }
        if (!_.isEmpty(sorter)) {
            if (sorter.order) {
                query = {
                    ...query,
                    sort_field: sorter.field,
                    sort_type: sorter.order === 'ascend' ? 'ASC' : 'DESC'
                }
            } else {
                delete query.sort_field;
                delete query.sort_type;
            }
        }

        this.props.history.push({
            pathname: this.props.location.pathname,
            search: qs.stringify(query),
        });
    }

    onSelectChange = selectedRowKeys => {
        this.setState({ selectedRowKeys });
    };


    render() {

        var { isLoading, selectedRowKeys } = this.state;
        var { zalo_oa_list, pagination } = this.props;
        var query = qs.parse(this.props.location.search.slice(1));

        const rowSelection = {
            selectedRowKeys,
            onChange: this.onSelectChange,
        };

        const columns = [
            {
                title: 'ID',
                dataIndex: 'id',
                key: 'id',
                width: '50px',
                sorter: true
            },
            {
                title: 'Name',
                dataIndex: 'name',
                key: 'name',
                render: (text, record) => {
                    return (
                        <>
                            <Avatar icon={<UserOutlined />} src={record.avatar} /> &nbsp;
                            {record.name}
                        </>
                    )
                }
            },
            {
                title: 'OA ID',
                dataIndex: 'oa_id',
                key: 'oa_id',
                width: '150px'
            },
            {
                title: 'Follower',
                dataIndex: 'num_follower',
                key: 'num_follower',
                width: '100px'
            },
            {
                title: 'Package name',
                dataIndex: 'package_name',
                key: 'package_name',
                width: '150px'
            },
            {
                title: 'Token expires',
                dataIndex: 'expires_at',
                key: 'expires_at',
                width: '150px',
                render: (text) => {
                    return text ? (
                        <div>{isValidDate(text, true)}</div>
                    ) : (
                        <Tag></Tag>
                    );
                }
            },
            {
                title: 'Package expires',
                dataIndex: 'package_valid_through_date',
                key: 'package_valid_through_date',
                width: '150px',
                render: (text) => {
                    return text ? (
                        <div>{isValidDate(text, false)}</div>
                    ) : (
                        <Tag></Tag>
                    );
                }
            },
            {
                title: 'Description',
                dataIndex: 'description',
                key: 'description',
                width: '200px',
                render: (text, record) => (
                    <div style={{ wordBreak: "break-word" }}>
                        <Tooltip title={HtmlParser(text)}>
                            <TextTruncate line={2} truncateText="…" text={stripHtml(text)} />
                        </Tooltip>
                    </div>
                )
            }
        ];

        return (
            <div>
                <PageTitle routes={routes} title="Zalo Oa" />
                <div>
                    <TableActionBar
                        isShowAddButton={false}
                        isShowDeleteButton={false}
                        addText="Thêm trang"
                        showFilter={false}
                        onSearch={(value) => this.onChangeFilter('keyword', value)}
                        defaultKeyword={query.keyword}
                    >
                        {
                            checkPermission('zalo', 'grant_permission') ? (
                                <>
                                    <Button className='table-button' type='primary' onClick={() => this.openPopup()}>
                                        Kết nối với Zalo OA
                                    </Button>
                                </>
                            ) : null
                        }
                        <Button className="table-button" type='dashed' icon={<ReloadOutlined />} loading={isLoading} onClick={() => this.reloadData()}>Refresh</Button>
                    </TableActionBar>
                </div>
                <Table
                    rowKey="id"
                    size="small"
                    tableLayout='auto'
                    dataSource={zalo_oa_list}
                    columns={columns}
                    loading={isLoading}
                    rowSelection={rowSelection}
                    pagination={{
                        pageSize: pagination.perPage,
                        current: pagination.currentPage,
                        total: pagination.total,
                        showTotal: total => `Tổng ${total} bản ghi`
                    }}
                    onChange={(pagination, filters, sorter) => this.onChangeTable(pagination, sorter)}
                    scroll={{
                        x: 'max-content'
                    }}
                />
            </div>

        );
    }
}

function mapStateToProps(state) {
    console.log(state.Zalo);
    return {
        zalo_oa_list: state.Zalo.zalo_oa_list,
        pagination: state.Zalo.pagination
    }
}

function mapDispatchToProps(dispatch) {
    return {
        getListOa: (filter) => dispatch(getListOa(filter)),
        grantPermission: () => dispatch(grantPermission()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ZaloOAList);
